<template>
  <div class="policy-page">
    <h1>商务诚信法规</h1>
    <policy-list
        :list="employmentList"
        @item-click="handlePolicyClick"
    />
  </div>
</template>

<script>
import PolicyList from '@/components/PolicyList.vue'
export default {
  name: "LawsList",
  components: { PolicyList },
  data() {
    return {
      employmentList: [
        {
          title: '《中华人民共和国招标投标法》',
          url: 'http://www.npc.gov.cn/zgrdw/npc/xinwen/2018-01/04/content_2036284.htm'
        },
        {
          title: '《中华人民共和国政府采购法》',
          url: 'https://www.gov.cn/gongbao/content/2002/content_61590.htm'
        },
        {
          title: '《中华人民共和国基本医疗卫生与健康促进法》',
          url: 'https://www.nhc.gov.cn/fzs/c100048/202007/e1192329ea4d45ef892892cd8232d385.shtml'
        },
        {
          title: '《学校食堂大宗食材采购验收管理工作指引》',
          url: 'http://www.moe.gov.cn/srcsite/A17/moe_943/s3283/202509/t20250908_1412385.html'
        },
        {
          title: '《关于规范中央企业采购管理工作的指导意见》',
          url: 'https://www.gov.cn/gongbao/2024/issue_11566/202409/content_6973172.html'
        },
        {
          title: '《评标专家和评标专家库管理办法》',
          url: 'https://www.gov.cn/gongbao/2024/issue_11706/202411/content_6987947.html'
        },
        {
          title: '《中华人民共和国招标投标法实施条例》',
          url: 'https://www.gov.cn/gongbao/content/2019/content_5468831.htm'
        },
        {
          title: '《中华人民共和国政府采购法实施条例》',
          url: 'https://www.gov.cn/zhengce/content/2015-02/27/content_9504.htm'
        },
        {
          title: '《中华人民共和国反不正当竞争法》',
          url: 'http://www.npc.gov.cn/zgrdw/npc/xinwen/2019-05/07/content_2086834.htm'
        },
        {
          title: '《优化营商环境条例》',
          url: 'https://www.gov.cn/zhengce/content/2019-10/23/content_5443963.htm#'
        },
        {
          title: '《失信行为纠正后的信用信息修复管理办法(试行)》',
          url: 'https://www.gov.cn/gongbao/content/2023/content_5750625.htm'
        },
        {
          title: '《中共中央 国务院关于加快建设全国统一大市场的意见》',
          url: 'https://www.gov.cn/gongbao/content/2022/content_5687499.htm'
        },
        {
          title: '《国务院关于促进市场公平竞争维护市场正常秩序的若干意见》',
          url: 'https://www.gov.cn/gongbao/content/2014/content_2717358.htm'
        },
        {
          title: '《中共中央办公厅 国务院办公厅关于健全社会信用体系的意见》',
          url: 'https://www.gov.cn/gongbao/2025/issue_11986/202504/content_7019258.html'
        },
        {
          title: '《关于推进社会信用体系建设高质量发展促进形成新发展格局的意见》',
          url: 'https://www.gov.cn/gongbao/content/2022/content_5686028.htm'
        },
        {
          title: '《国务院关于建立完善守信联合激励和失信联合惩戒制度加快推进社会诚信建设的指导意见》',
          url: 'https://www.gov.cn/gongbao/content/2016/content_5086307.htm'
        },
        {
          title: '《商务部 国家发展改革委 金融监管总局关于推动商务信用体系建设高质量发展的指导意见》',
          url: 'https://www.gov.cn/zhengce/zhengceku/202308/content_6900101.htm'
        },
        {
          title: '《国家发展改革委办公厅关于充分发挥信用服务机构作用加快推进社会信用体系建设的通知》',
          url: 'https://www.gov.cn/zhengce/zhengceku/2018-12/31/content_5435244.htm'
        },
        {
          title: '《关于建立健全招标投标领域优化营商环境长效机制的通知》',
          url: 'https://www.ndrc.gov.cn/xwdt/tzgg/202102/t20210225_1267906.html'
        },
        {
          title: '《武器装备科研生产许可（备案）单位失信管理暂行办法》',
          url: 'https://www.sastind.gov.cn/n10086167/n10086221/c10129267/content.html'
        },
        {
          title: '《铁路工程建设项目招标投标管理办法》',
          url: 'https://www.gov.cn/zhengce/zhengceku/2018-12/31/content_5444285.htm'
        },
        {
          title: '《水利工程建设项目招标投标管理规定》',
          url: 'https://www.gov.cn/gongbao/content/2002/content_61624.htm'
        },
        {
          title: '《公路工程建设项目招标投标管理办法》',
          url: 'https://www.gov.cn/gongbao/content/2016/content_5054736.htm'
        }
      ],
    }
  },
  created() {
  },
  methods: {
    handlePolicyClick(url) {
      console.log(url)
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>

.policy-page {
  padding: 20px;
  max-width: 1000px;
  min-height: calc(100vh - 150px);
  margin: 0 auto;

  background-color: #ffffff;
}

h1 {
  margin-bottom: 20px;
  text-align: center;
  color: #333;
  font-size: 24px;
  font-weight: bold;
}
</style>
